"use strict";

import Toolbox from "./toolbox";
import { ItemListingState, ItemListingConfig, itemListingConfigModifier } from "./listing-helper";

class ProductListPromotions {

	constructor(state, config) {

		this.state = state || ItemListingState;
		this.config = config || ItemListingConfig;

	}

	/**
	 * Get promotion item.
	 * 
	 * @returns {Node} - Promotion item.
	 */
	getPromotionItem() {
		const info = document.createElement("div");
		let selectedPromo = 0;

		if (!this.state.promoItemCounters.shownPromos) {
			this.state.promoItemCounters.shownPromos = [];
		}

		if (this.state.promoItems.length > 1) {
			
			for (let i = 0; i < this.state.promoItems.length; i++) {
				if (i > this.state.promoItemCounters.selectedPromoIndex) {
					selectedPromo = i;
					break;
				}
				
			}
		}

		this.state.promoItemCounters.selectedPromoIndex = selectedPromo;

		info.innerHTML = this.state.promoItems[selectedPromo];
		return info.firstChild;
	}

	/**
	 * Add promotion item.
	 * 
	 * @param {Node} nodes - Node or nodes.
	 * @param {boolean} insertAfterCurrentNode - Insert after node (nodes must be singel node).
	 */
	addPromotionItem(nodes, insertAfterCurrentNode) {
		this.state.promoItemCounters.itemsBetweenPromosCounter = 0;
		this.state.promoItemCounters.promoItemCounter++;
		if (nodes) {
			if (insertAfterCurrentNode === true) {
				nodes.parentNode.insertBefore(this.getPromotionItem(), nodes.nextSibling);
			} else {
				if (nodes.length !== undefined) {
					for (const node of nodes) {
						node.appendChild(this.getPromotionItem());
					}
				} else {
					nodes.appendChild(this.getPromotionItem());
				}

			}
		}
	}

	/**
	 * Handles adding promotion items in product list. Also check ProductFetcher class' fetch method.
	 * This will add promotion items in existing product list.
	 * 
	 * @returns {boolean} - True if page had promotion items, otherwise false.
	 */
	addPromotionItemsToList() {

		const promoItemTemplates = document.querySelectorAll(".product-list-promo-item");

		if (promoItemTemplates.length > 0) {
			this.state.promoItemCounters.hasPromoItems = true;
			for (const promoItem of promoItemTemplates) {
				this.state.promoItems.push(String(promoItem.textContent).trim());
			}
			if (this.state.promoItems.length > 1) {
				// Let's keep the original order.
				//Toolbox.shuffleList(this.state.promoItems);
				this.state.promoItemCounters.showMaxPromoItems = this.state.promoItems.length;
			}
		} else {
			return false;
		}

		const productItems = document.querySelectorAll(".product-list.js-product-list.custom-category-listing article, .product-list-grid.js-product-list.custom-category-listing article");

		const randStart = Toolbox.randomBetween(this.state.promoItemCounters.promoItemStartPosition - 2, this.state.promoItemCounters.promoItemStartPosition + 1);
		let addedPromoItem = false;
		for (let index = 0; index < productItems.length; index++) {

			if (this.state.promoItemCounters.promoItemCounter >= this.state.promoItemCounters.showMaxPromoItems) {
				break;
			}

			if (this.state.promoItemCounters.promoItemCounter < this.state.promoItemCounters.showMaxPromoItems) {

				const productItem = productItems[index];
				if (productItems.length > this.state.promoItemCounters.promoItemShowAfterEvery && (randStart === this.state.promoItemCounters.itemCounter)) {
					this.addPromotionItem(productItem, true);
					addedPromoItem = true;
					this.state.promoItemCounters.itemCounter = this.state.promoItemCounters.promoItemShowAfterEvery + this.state.promoItemCounters.promoItemRandomRange;
				} else {
					if (this.state.promoItemCounters.itemsBetweenPromosCounter >= this.state.promoItemCounters.minItemsBetweenPromos) {
						const randomPromoPosition = Toolbox.randomBetween(this.state.promoItemCounters.promoItemShowAfterEvery - this.state.promoItemCounters.promoItemRandomRange, this.state.promoItemCounters.promoItemShowAfterEvery + this.state.promoItemCounters.promoItemRandomRange);
						if (this.state.promoItemCounters.itemCounter % randomPromoPosition === 0 && this.state.promoItemCounters.itemCounter !== 0) {
							this.addPromotionItem(productItem, true);
							addedPromoItem = true;
						}
					}
				}
				this.state.promoItemCounters.itemsBetweenPromosCounter++;
				this.state.promoItemCounters.itemCounter++;

				if ((this.state.promoItemCounters.itemsBetweenPromosCounter >= this.state.promoItemCounters.maxItemsBetweenPromos) && (this.state.promoItemCounters.promoItemCounter < this.state.promoItemCounters.showMaxPromoItems)) {
					this.addPromotionItem(productItem, true);
					addedPromoItem = true;
				}

			}

		}

		if (productItems.length > 0 && productItems.length <= this.state.promoItemCounters.promoItemShowAfterEvery && addedPromoItem === false
			&& (this.state.promoItemCounters.promoItemCounter < this.state.promoItemCounters.showMaxPromoItems)) {
			const productList = document.querySelectorAll(this.config.listingSelector);
			this.addPromotionItem(productList);
		}

		return true;

	}

}

export default ProductListPromotions;